import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import CostingCard from '@components/CostingCard';

import CollectionViewItemsCostingItems from '@features/costing/components/CostingManager/CollectionViewItemsCostingItems';
import TopFilter from '@features/costing/components/TopFilter';
import { generateTeamParams } from '@features/filter/static/filterUtil';

import { clearCosting, fetchAllQuoteRequest, setCostingActiveTab } from '@store/actions/CostingAction';
import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { checkUserType, isPageReachBottom } from '@utils/Util';

const ListOfCostingForAccountManager = ({ requestFrom }) => {
	const [listOfCosting, setListOfCosting] = useState({});
	const costingStore = useSelector((store) => store.costingStore);
	const [activeTab, setActiveTab] = useState(costingStore?.activeTab);
	const [page, setPage] = useState(0);
	const dispatch = useDispatch();
	const myStateRef = useRef({});
	const myTeamMembers = useSelector((store) => store.teamMembersReducer);

	const setMyState = (data) => {
		myStateRef.current = data;
	};

	useEffect(() => {
		document.addEventListener('scroll', handleScroll);
		return () => {
			document.removeEventListener('scroll', handleScroll);
		};
	}, []);

	useEffect(() => {
		window.scrollTo(0, 0);
		setPage(0);
		// dispatch(fetchQuoteCount(generateCountParams()));
		if (!isFashionDesigner()) fetchCostingRequest(0);
	}, [activeTab, costingStore.filterField, myTeamMembers]);

	useEffect(() => {
		if (page !== 0) {
			// dispatch(fetchQuoteCount(generateCountParams()));
			if (!isFashionDesigner()) fetchCostingRequest(page);
		}
	}, [page]);

	useEffect(() => {
		setActiveTab(costingStore?.activeTab);
	}, [costingStore.activeTab]);

	useEffect(() => {
		setListOfCosting(costingStore.response);
		setMyState(costingStore.response);
	}, [costingStore.response]);

	const handleTab = (value) => {
		dispatch(clearCosting());
		setActiveTab(value);
		dispatch(setCostingActiveTab(value));
		setPage(0);
	};

	// const getActiveStatus = {
	// 	PENDING: 'PENDING,RUNNING',
	// 	COMPLETED: 'COMPLETED',
	// 	ARCHIVE: 'ARCHIVE'
	// };

	const isFashionDesigner = () => {
		return checkUserType('FASHION_DESIGNER');
	};

	const generateParams = (pageNumber) => {
		let params = `?page=${pageNumber}&size=15&status=${activeTab}&sort=modifiedAt,desc`;
		if (Object.keys(costingStore.filterField).length > 0) {
			if (costingStore.filterField?.search) {
				params += `&search=${costingStore.filterField?.search}`;
			}
			if (costingStore.filterField?.brand?.id) {
				params += `&brandId=${costingStore.filterField.brand.id}`;
			}
			if (costingStore.filterField?.collection?.id) {
				params += `&collectionId=${costingStore.filterField.collection.id}`;
			}
			if (costingStore.filterField?.requestedBy?.id) {
				params += `&requestedBy=${costingStore.filterField.requestedBy.id}`;
			}
		}
		return generateTeamParams(myTeamMembers, params);
	};

	const fetchCostingRequest = (pageNumber) => {
		if (activeTab) {
			dispatch(openLoader());
			dispatch(fetchAllQuoteRequest(generateParams(pageNumber), pageNumber !== 0)).finally(() =>
				dispatch(closeLoader())
			);
		}
	};

	const handleScroll = () => {
		if (!isFashionDesigner() && isPageReachBottom()) {
			let { totalElements, currentPage, data } = myStateRef.current;
			if (totalElements > 0 && totalElements !== data.length) {
				setPage(currentPage + 1);
			}
		}
	};

	const renderDesign = () => {
		if (isFashionDesigner() && activeTab === 'PENDING,RUNNING') {
			return <CollectionViewItemsCostingItems status="REQUESTED" />;
		} else if (isFashionDesigner() && activeTab === 'COMPLETED') {
			return <CollectionViewItemsCostingItems status="COMPLETED" />;
		} else {
			return listOfCosting?.data?.map((item) => {
				return (
					<div className="sample-items-row" key={`costing_item_${item.id}`}>
						<div>
							<CostingCard costingItem={item} />
						</div>
					</div>
				);
			});
		}
	};

	const renderAlertMessage = () => {
		if (listOfCosting?.data?.length === 0) {
			return (
				<div className="alert alert-secondary text-center w-100">
					<p>No costing request found</p>
				</div>
			);
		}
	};

	const onSetpage = () => setPage(0);

	return (
		<div>
			{requestFrom !== 'CRM' && (
				<div className="top-header bg-white">
					<div className="page-title-area">
						<h1 className="semibold-16">Costing</h1>
					</div>
					<div className="navigation-tab shadow-nav-4dp">
						<ul>
							<li
								onClick={() => handleTab('PENDING,RUNNING')}
								className={activeTab === 'PENDING,RUNNING' ? 'active' : ''}
							>
								Pending
							</li>
							<li
								onClick={() => handleTab('COMPLETED')}
								className={activeTab === 'COMPLETED' ? 'active' : ''}
							>
								Complete
							</li>
							{!isFashionDesigner() && (
								<li
									onClick={() => handleTab('ARCHIVE')}
									className={activeTab === 'ARCHIVE' ? 'active' : ''}
								>
									Archive
								</li>
							)}
						</ul>
					</div>
					<TopFilter managerType="ACCOUNT_MANAGER" onSetpage={onSetpage} />
				</div>
			)}
			<div
				className={
					isFashionDesigner()
						? 'sample-dashboard-container status-two-column bg-white'
						: 'sample-dashboard-container status-two-column'
				}
			>
				<div className="designs-collections-container">
					{renderAlertMessage()}
					<div>{renderDesign()}</div>
				</div>
			</div>
		</div>
	);
};

export default ListOfCostingForAccountManager;
